import React from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Modal
} from '@material-ui/core';
import { PictureImage } from './PictureImage';
import { TPicture } from '../../types/cloudStorage/CloudFileList';
import {
  ModalCancelButton,
  ModalDeleteButton
} from '../parts/cloudStorage/style/style';

type Tprops = {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedPictures: TPicture[];
  onDeletePictures: () => void;
};

export const DeleteModal: React.FC<Tprops> = (props: Tprops) => {
  const { modalOpen, setModalOpen, selectedPictures, onDeletePictures } = props;

  const classes = useStyles();

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ marginBottom: 24, fontSize: 24 }}>写真を削除</h1>
            <p>選択した写真を削除しますか？</p>
          </div>
        </Grid>

        <div className={classes.body}>
          <Grid container justify={'center'}>
            {selectedPictures.map(picture => (
              <Grid item>
                <div key={picture.id} style={{ margin: '8px' }}>
                  <PictureImage picture={picture} src={picture.src} />
                </div>
              </Grid>
            ))}
          </Grid>
        </div>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setModalOpen(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton variant='contained' onClick={onDeletePictures}>
            削除する
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '50%',
      maxHeight: '90vh',
      overflowY: 'scroll'
    },

    header: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(2, 2, 0, 0)
    },
    headerTitle: {
      fontSize: 30,
      marginTop: 10,
      marginBottom: 10
    },
    headerText: {
      fontSize: 20,
      marginTop: 10,
      marginBottom: 10
    },

    body: {
      backgroundColor: theme.palette.background.paper
    },
    bodyListArea: {
      maxHeight: '300px',
      width: '100%',
      padding: theme.spacing(5),
      display: 'flex'
    },

    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    }
  })
);
